import ProductShow from "./ProductShow";
import Wrapper from "../assets/wrappers/Lightbox";

type LightboxProps = {
  closeLightbox: () => void;
  openLightbox: () => void;
  isLightboxOpen: boolean;
};

const Lightbox = ({
  closeLightbox,
  openLightbox,
  isLightboxOpen,
}: LightboxProps) => {
  return (
    <Wrapper onClick={(e) => e.stopPropagation()}>
      <div className="btn-container">
        <button onClick={closeLightbox} className="btn-close">
          <svg
            className="icon-close"
            width="14"
            height="15"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m11.596.782 2.122 2.122L9.12 7.499l4.597 4.597-2.122 2.122L7 9.62l-4.595 4.597-2.122-2.122L4.878 7.5.282 2.904 2.404.782l4.595 4.596L11.596.782Z"
              fill="#69707D"
              fillRule="evenodd"
            />
          </svg>
        </button>
      </div>
      <ProductShow
        isLightboxOpen={isLightboxOpen}
        openLightbox={openLightbox}
      />
    </Wrapper>
  );
};

export default Lightbox;
